// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1fP5t","label":"SetPasswdForm_label__3-asN"};